import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import LanguagesAndTools from '../components/LanguagesAndTools';
import GamingStudent from "../components/GamingStudent";
import { Link } from "react-router-dom";
import { FaGamepad, FaCode, FaRobot } from 'react-icons/fa';

import myPhoto1 from "./page_Images/MyPhotos/WTCgraduation.webp";
import myPhoto2 from "./page_Images/MyPhotos/DbugGuy.webp";

const Home = () => {
  const [currentPhoto, setCurrentPhoto] = useState(myPhoto1);
  const [xp, setXp] = useState(0);
  const [level, setLevel] = useState(1);
  const [notification, setNotification] = useState("");

  // Level up logic
  useEffect(() => {
    const newLevel = Math.floor(xp / 100) + 1;
    if (newLevel > level) {
      setLevel(newLevel);
      showNotification(`LEVEL UP! You are now Level ${newLevel}`);
    }
  }, [xp, level]);

  const showNotification = (msg) => {
    setNotification(msg);
    setTimeout(() => setNotification(""), 3000);
  };

  const handleImageClick = () => {
    setCurrentPhoto((prev) => (prev === myPhoto1 ? myPhoto2 : myPhoto1));
    setXp(prev => prev + 10);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      handleImageClick();
    }
  };

  return (
    <Layout>
      {/* Gamification HUD */}
      <div className="fixed bottom-4 left-4 md:top-24 md:right-8 md:bottom-auto md:left-auto bg-gray-900/90 backdrop-blur text-green-400 p-3 md:p-4 rounded-lg border-2 border-green-500 shadow-[0_0_10px_rgba(0,255,0,0.5)] z-50 font-mono text-xs md:text-sm transition-all duration-300">
        <div className="flex items-center gap-2 mb-2">
            <FaGamepad /> <span>Player Stats</span>
        </div>
        <div className="flex justify-between mb-1">
            <span>Lvl {level}</span>
            <span>{xp % 100} / 100 XP</span>
        </div>
        <div className="w-32 md:w-48 bg-gray-700 h-2 rounded overflow-hidden">
            <div 
                className="bg-green-500 h-full transition-all duration-300 ease-out" 
                style={{ width: `${xp % 100}%` }}
            ></div>
        </div>
      </div>

      {/* Notification Popup */}
      {notification && (
        <div className="fixed top-24 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-black font-bold px-6 py-3 rounded-full shadow-2xl animate-bounce z-50 border-4 border-white flex items-center gap-2">
            <FaGamepad /> {notification}
        </div>
      )}

      <div className="bg-gradient-to-r from-slate-900 to-slate-800 text-white p-8 rounded-2xl shadow-2xl flex flex-col md:flex-row items-center md:items-start gap-16 border border-slate-700 relative overflow-hidden">
        
        {/* Background decoration */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 opacity-5 rounded-full blur-3xl -mr-20 -mt-20 pointer-events-none"></div>

        {/* Left Section: Text */}
        <div className="flex-1 z-10">
          <div className="inline-flex items-center px-3 py-1 bg-blue-900/50 rounded-full text-xs font-mono mb-6 border border-blue-500/30 text-blue-300">
            <FaRobot className="mr-2"/> AI ENGINEER & FULL STACK DEV
          </div>
          
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight mb-6 leading-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              Level Up Your
            </span> <br/>
            Digital Experience
          </h1>
          
          <p className="mt-4 text-lg text-gray-300 leading-relaxed max-w-xl">
            I build intelligent systems and immersive web applications that engage users and solve complex problems. Ready to start the mission?
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <Link to="/projects" onClick={() => setXp(prev => prev + 20)}>
              <button className="px-8 py-4 bg-cyan-600 text-white font-bold rounded-lg hover:bg-cyan-500 transition-all duration-300 shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:shadow-[0_0_25px_rgba(6,182,212,0.8)] transform hover:-translate-y-1 active:scale-95 flex items-center gap-2">
                <FaGamepad /> Start Mission
              </button>
            </Link>
            <button 
                className="px-8 py-4 border border-gray-600 text-gray-300 font-bold rounded-lg hover:bg-gray-800 hover:border-gray-400 transition-all duration-300 active:scale-95"
                onClick={() => {
                    setXp(prev => prev + 5);
                    showNotification("Secret Found: +5 XP");
                }}
            >
                View Stats
            </button>
          </div>
        </div>

        {/* Right Section: Profile Image */}
        <div className="profile-image-container flex justify-center items-center flex-1 z-10 relative mt-8 md:mt-0">
            <div 
              role="button"
              tabIndex={0}
              onClick={handleImageClick}
              onKeyDown={handleKeyDown}
              className="cursor-pointer focus:outline-none group relative"
              title="Click to change photo & gain XP"
              aria-label="Toggle profile photo"
            >
              <div className="absolute -inset-1 bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse"></div>
              <img 
                src={currentPhoto} 
                alt="My Profile" 
                className="relative w-64 h-64 object-cover rounded-full border-4 border-gray-900 shadow-2xl transition-transform duration-300 group-hover:scale-105 group-active:scale-95" 
              />
              <div className="absolute bottom-2 right-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-full border-2 border-gray-900 shadow-lg transform group-hover:scale-110 transition-transform">
                +10 XP
              </div>
            </div>
        </div>
      </div>

      <div className="mt-16">
        <h2 className="text-3xl font-bold text-center mb-10 text-gray-800 dark:text-white flex items-center justify-center gap-3">
            <FaCode className="text-blue-500"/> Tech Stack Arsenal
        </h2>
        <LanguagesAndTools />
      </div>
  
      <GamingStudent />
    </Layout>
  );
};

export default Home;
